import { IndividualDay } from 'shared/interfaces/days-of-week.interface';

export const dayArray: IndividualDay[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
